/**
 * Calcula a posição geral de um item tendo como base: 1° - a posição do item na página em que ele está,
 * 2° - a quantidade de itens exibidos por página e 3° - página atual em que o item se encontra. Retornando
 * os itens selecionados e todas as páginas que possuem itens selecionados.
 *
 * @param {number} positionInCurrentPage - Posição do item selecionado, na página em que se encontra.
 * @param {number} lengthTable - Quantidade de itens exibidos por página.
 * @param {Array<IItenPositionWithYourPage>} generalPositionsOfItensSelected - Itens que já estão selecionados.
 * @param {boolean} selectingAll - Está selecionando todos os itens da página.
 * @param {boolean} unSelectingAll - Está deselecionando todos os itens da página.
 */
export const getGeneralPositionOfItemSelected = (
	positionInCurrentPage: number,
	lengthTable: number,
	generalPositionsOfItensSelected: Array<IItenPositionWithYourPage>,
	selectingAll: boolean,
	unSelectingAll: boolean,
	currentPage: number
): IAllItensPositionAndPagesSelected => {
	 let generalPosition: number = 0

	/*
		Se o item selecionado estiver na primeira página, a posição geral do item é o index atual
		Se não, calculamos a posição geral baseado na página atual e na quantidade de itens por página
	*/
	 if (currentPage == 0) {
		generalPosition = positionInCurrentPage
	} else if (currentPage > 0) {
		generalPosition =
			positionInCurrentPage +	(currentPage * lengthTable)
	}

	// Verifica se a posição do item selecionado já está no Array de posições selecionadas
	 const indexGeneralPositions: number =
		generalPositionsOfItensSelected.findIndex(item => item.generalPosition === generalPosition)

	// Se estiver selecionando todos os itens da lista, apenas coloca se não estiver selecionado
	 if (selectingAll && indexGeneralPositions == -1) {
		generalPositionsOfItensSelected.push({
			generalPosition,
			page:  currentPage + 1
		})

	// Se estiver deselecionando todos, retira se já está selecionado
	} else if (unSelectingAll && indexGeneralPositions > -1) {
		generalPositionsOfItensSelected.splice(indexGeneralPositions, 1)
	} else if (!selectingAll && !unSelectingAll) {
		/*
			Se o item ainda não foi selecionado, armazenamos a sua posição geral no
			Array de posições gerais selecionadas. Se não, removemos a posição do Array
			de posições gerais selecionadas
		*/
		if (indexGeneralPositions == -1) {
			generalPositionsOfItensSelected.push({
				generalPosition,
				page:  currentPage + 1
			})
		} else {
			generalPositionsOfItensSelected.splice(indexGeneralPositions, 1)
		}
	}

		// Extrai a página de cada Itens que selecionado
		const allPagesFromItensSelected: Array<number> =
		generalPositionsOfItensSelected.map(item => item.page)

		// Extrai todas as páginas removendo as duplicadas
		const pagesNotDuplicate = Array.from(new Set(allPagesFromItensSelected))

		return {
				allItensSelected: generalPositionsOfItensSelected,
				allPagesSelected: pagesNotDuplicate.sort()
		}
}

/**
 * Itera sobre os itens selecionados para redefinir a página em que o item se encontra
 * com base na quantidade de itens exibidos por página
 *
 * @param {number} lengthTable - Quantidade de itens exibidos por página.
 * @param {Array<IItenPositionWithYourPage>} generalPositionsOfItensSelected - Itens que já estão selecionados.
 */
export  const recalculatePagePositionOfItensSelected = (
	lengthTable: number,
	generalPositionsOfItensSelected: Array<IItenPositionWithYourPage>
): IAllItensPositionAndPagesSelected => {

	generalPositionsOfItensSelected.forEach(item => {
		item.page = Math.ceil(item.generalPosition / lengthTable)
	})

	// Extrai a página de cada Itens que selecionado
 const allPagesFromItensSelected: Array<number> =
		generalPositionsOfItensSelected.map(item => item.page)

		// Extrai todas as páginas removendo as duplicadas
 const pagesNotDuplicate = Array.from(new Set(allPagesFromItensSelected))

	return {
				allItensSelected: generalPositionsOfItensSelected,
				allPagesSelected: pagesNotDuplicate.sort()
		}
}

export const runToPageSelected = (pageSelected: number) => {
		const dataTableInstance = $('#dataTable').DataTable()
		dataTableInstance.page(pageSelected).draw('page')
}

export const getCurrentPage = (): number => {
		const dataTableInstance = $('#dataTable').DataTable()

		return dataTableInstance.page.info().page
}

export interface IItenPositionWithYourPage {
	generalPosition: number
	page: number
}

export interface IAllItensPositionAndPagesSelected {
		allItensSelected: Array<IItenPositionWithYourPage>,
		allPagesSelected: Array<number>
}
